import { TemplateElement, html, defineElement } from '@webtides/element-js';
// import style from './show-hide.css';

export default class ShowHide extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    connected() {
        this.evaluateHeights();
        this.$refs.content.classList.add('auto-height');

        try {
            const resizeObserver = new ResizeObserver(() => {
                this.evaluateHeights();
            });
            resizeObserver.observe(this.firstElementChild);
        } catch (e) {
            /**
             *  just catch errors to not produce js errors if ResizeOberserver is not supported
             *  */
        }
    }

    evaluateHeights() {
        let initialHeight = 0;
        let totalHeight = 0;
        this.querySelectorAll(this.rowSelector).forEach((row, index) => {
            let rowHeight = 0;
            if (index < this.initiallyVisible) {
                this.isShowMore = false;
                rowHeight = row.scrollHeight;
                let style = getComputedStyle(row);
                rowHeight += parseInt(style.marginTop) + parseInt(style.marginBottom);

                initialHeight += rowHeight;
            } else {
                this.isShowMore = true;
            }
        });

        this.totalHeight = this.$refs.content.scrollHeight;
        this.initialHeight = initialHeight;
    }

    properties() {
        return {
            open: false,
            rowSelector: '.row',
            initiallyVisible: 0,
            initialHeight: 0,
            totalHeight: 0,
            fadeOut: false,
            isShowMore: true,
        };
    }

    events() {
        return {
            '[data-toggle]': {
                click: () => {
                    this.toggle();
                },
            },
        };
    }

    toggle() {
        this.evaluateHeights();
        this.open = !this.open;
    }

    show() {
        this.evaluateHeights();
        this.open = true;
    }

    hide() {
        this.evaluateHeights();
        this.open = false;
    }

    template() {
        return html`
            <div
                class="content-wrapper relative overflow-hidden"
                ref="content"
                style="max-height: ${this.open ? this.totalHeight + 'px' : this.initialHeight + 'px'}">
                <slot name="content"></slot>

                ${this.fadeOut && !this.open
                    ? html`
                          <div class="fade-out-overlay absolute bottom-0 left-0 right-0 h-12"></div>
                      `
                    : html``}
            </div>
            <slot
                name="action-show"
                data-toggle
                ref="actionShow"
                class="${this.open === true || this.isShowMore === false ? 'hidden' : ''}"></slot>
            <slot name="action-hide" data-toggle ref="actionHide" class="${this.open === false ? 'hidden' : ''}"></slot>
        `;
    }
}

export function define() {
    defineElement('show-hide', ShowHide);
}
